import { render } from "./ACMG.vue?vue&type=template&id=9dcdfd6c&scoped=true"
import script from "./ACMG.vue?vue&type=script&lang=js"
export * from "./ACMG.vue?vue&type=script&lang=js"

import "./ACMG.vue?vue&type=style&index=0&id=9dcdfd6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dcdfd6c"]])

export default __exports__